import './index.css'

import React from 'react'
import { DiscoModal } from 'components/ui'
import Button from 'components/ui/button'
import Heading from 'components/ui/heading'
import { modalWindowStyles } from 'components/utils/modalStyles'
type Props = {
  title: string
  sidebar: React.ReactNode
  content: React.ReactNode
  actions?: React.ReactNode
  onClose: (...args: Array<any>) => any
}

/**
 * A modal component with a sidebar layout containing a title, sidebar content, main content, and actions
 * @param title - The title displayed at the top of the sidebar
 * @param sidebar - The content displayed in the left sidebar area
 * @param content - The main content displayed in the right area
 * @param actions - Optional action buttons displayed at the bottom of the right area
 * @param onClose - Callback function called when the modal is closed
 * @returns A sidebar modal component with left sidebar and right content area
 */
const SidebarModal = (props: Props): React.ReactNode => {
  return (
    <DiscoModal
      closeTimeoutMS={200}
      onRequestClose={props.onClose}
      isOpen={true}
      style={modalWindowStyles}
    >
      <div className="sidebar-modal">
        <div className="sidebar-modal-left">
          <div className="sidebar-modal-title">
            <Heading size={700}>{props.title}</Heading>
          </div>
          {props.sidebar}
        </div>
        <div className="sidebar-modal-right">
          <div className="sidebar-modal-close">
            <Button appearance="icon" icon="close" onClick={props.onClose} />
          </div>
          <div className="sidebar-modal-content">
            <div>{props.content}</div>
          </div>
          <div className="sidebar-modal-actions">{props.actions}</div>
        </div>
      </div>
    </DiscoModal>
  )
}

export default SidebarModal
